<template>
  <vs-popup fullscreen v-if="file" :title="file.file_name" :active="active" @update:active="updateActive">
    <div style="padding-bottom: 0;" class="flex items-center justify-center w-full inline">
      <feather-icon
        v-if="previous"
        :title="$t('Prev')"
        icon="ChevronLeftIcon"
        svgClasses="w-10 h-10 stroke-current"
        class="ml-2 mr-2 items-start items-baseline"
        @click.prevent="updateMessageId(previous.id)"
      />
      <auth-image class="object-contain" style="height: 75vh;" v-if="file.file_type=='image'" :path="file.path" />
      <auth-file v-else style="height: 75vh;border:none;overflow:hidden;overflow-x:hidden;overflow-y:hidden;" width="95%" height="85%" class="object-contain" :path="file.path"></auth-file>
      
      <feather-icon
        v-if="next"
        :title="$t('Next')"
        icon="ChevronRightIcon"
        svgClasses="w-10 h-10 stroke-current"
        class="ml-2 mr-2 items-start items-baseline"
        @click.prevent="updateMessageId(next.id)"
      />
    </div>
  </vs-popup>
</template>

<script>
import AuthImage from '@/components/auth/image';
import AuthFile from '@/components/auth/file';
import { mapGetters } from 'vuex'

export default {
  components: {
    AuthImage,
    AuthFile
  },
  props: {
    messageId: { type: Number, required: false },
    active: { type: Boolean, required: true },
  },
  computed: {
    ...mapGetters({
      messageList: 'chatMessages',
    }),
    messagesFile() {
      return this.messageList.filter(message => message.is_file && message.file && (message.file.file_type=='image' || message.file.file_type=='pdf'));
    },
    index() {
      const messageId = this.messageId;
      return this.messagesFile.findIndex(message => message.id == messageId);
    },
    file() {
      const message = this.messagesFile[this.index];
      if(message && message.file)
        return message.file;
      return null;
    },
    next() {
      const message = this.messagesFile[this.index + 1];
      return message ? message : null;
    },
    previous() {
      const message = this.messagesFile[this.index - 1];
      return message ? message : null;
    }
  },
  methods: {
    updateMessageId(messageId) {
      this.$emit('update:messageId', messageId);
    },
    updateActive(active) {
      this.$emit('update:active', active);
    }
  }
}
</script>

<style>

</style>